import { getValidationSchema } from "@features/run/RunGroupDialog/schema"
import { yupResolver } from "@hookform/resolvers/yup"
import { GraphDto } from "@custom-types/graphs"
import { UserPermissions } from "@custom-types/user"
import type { Resolver } from "react-hook-form"
import type { RunGroupFormValues } from "./RunGroupForm"

export function createRunGroupResolver(
  graph: GraphDto,
  permissions: UserPermissions | undefined,
): Resolver<RunGroupFormValues> {
  const schema = getValidationSchema(graph, permissions)
  return yupResolver(schema)
}
